module.exports = "/images/filter.png?4caa47aab741181c630a84d76ebec0e9";